module.exports = __webpack_public_path__ + "img/pt-01.734e5e98.svg";